import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LockIcon, ShieldCheckIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const productImages = ['https://cdn.magicpatterns.com/uploads/rKYFpz8GCiJ2B7MLiSNcKp/51TLDhszxRL._AC_SL1000_.jpg', 'https://cdn.magicpatterns.com/uploads/i3io3yp9NouzGRoD4GhybZ/71ihjKHcEZL._AC_SL1500_.jpg', 'https://cdn.magicpatterns.com/uploads/iXwFfrCuycVV6Be3vYQeJ5/515W8gFrbBL._AC_.jpg', 'https://cdn.magicpatterns.com/uploads/cfSvWLBp1h2hhBSuHjgsrq/613LfGEjdOL._AC_SL1158_.jpg', 'https://cdn.magicpatterns.com/uploads/83FZtuGY1f16S9rwYwz6We/5188DLIZfqL._AC_SL1001_.jpg'];
export function PricingSection() {
  const [imgIndex, setImgIndex] = useState(0);
  const nextImg = () => setImgIndex(prev => (prev + 1) % productImages.length);
  const prevImg = () => setImgIndex(prev => (prev - 1 + productImages.length) % productImages.length);
  const bundles = [{
    id: 2,
    qty: 2,
    name: 'Starter Edition',
    subtitle: 'Get 2 LumiMate',
    cta: 'Add Duo to Setup',
    price: 39.95,
    original: 49.95,
    badge: 'MOST POPULAR',
    highlight: true,
    url: 'https://purematte.com/cart/45908675592353:2'
  }, {
    id: 3,
    qty: 4,
    name: 'Office Setup Pack',
    subtitle: 'Get 4 LumiMate',
    cta: 'Upgrade to Quad-Logic',
    price: 65.95,
    original: 99.9,
    badge: null,
    url: 'https://purematte.com/cart/45908675592353:4'
  }, {
    id: 4,
    qty: 6,
    name: 'Ultimate Gift Pack',
    subtitle: 'Get 6 LumiMate',
    cta: 'Complete the Array',
    price: 79.95,
    original: 149.85,
    badge: 'BEST VALUE',
    highlight: true,
    url: 'https://purematte.com/cart/45908675592353:6'
  }];
  return <section id="bundles" className="py-12" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-8" data-id="element-78">
        <h2 className="text-3xl font-bold text-white mb-4" data-id="element-79">Choose Yours</h2>
        <p className="text-brand-orange font-medium" data-id="element-80">
          Buy 2+ and Unlock FREE Worldwide Shipping.
        </p>
        <p className="text-brand-muted text-sm mt-1" data-id="element-81">
          Perfect for gifting or a symmetrical dual-monitor setup.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="relative w-full max-w-md mx-auto mb-10 rounded-2xl overflow-hidden border border-white/10 bg-brand-card" data-id="element-82">
        <div className="relative aspect-square" data-id="element-83">
          <AnimatePresence mode="wait" data-id="element-84">
            <motion.img key={imgIndex} src={productImages[imgIndex]} alt={`LumiMate product view ${imgIndex + 1}`} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="absolute inset-0 w-full h-full object-contain bg-brand-card" data-id="element-85" />
          </AnimatePresence>

          <button onClick={prevImg} className="absolute left-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors z-10" data-id="element-86">
            <ChevronLeftIcon className="w-5 h-5" data-id="element-87" />
          </button>
          <button onClick={nextImg} className="absolute right-3 top-1/2 -translate-y-1/2 p-2 rounded-full bg-black/50 text-white hover:bg-black/70 transition-colors z-10" data-id="element-88">
            <ChevronRightIcon className="w-5 h-5" data-id="element-89" />
          </button>
        </div>

        <div className="flex justify-center gap-2 py-3" data-id="element-90">
          {productImages.map((_, i) => <button key={i} onClick={() => setImgIndex(i)} className={`h-2 rounded-full transition-all duration-300 ${i === imgIndex ? 'bg-brand-orange w-5' : 'bg-white/20 w-2 hover:bg-white/40'}`} data-id="element-91" />)}
        </div>
      </motion.div>

      <div className="flex flex-col gap-5 mb-8" data-id="element-92">
        {bundles.map((bundle, idx) => <motion.div key={bundle.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className={`relative p-6 rounded-2xl border ${bundle.highlight ? 'bg-brand-card border-brand-orange shadow-glow' : 'bg-brand-card/50 border-white/10'}`} data-id="element-93">
            {bundle.badge && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-full shadow-glow" data-id="element-94">
                {bundle.badge}
              </div>}

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-95">
              <div className="text-center sm:text-left" data-id="element-96">
                <h3 className="text-2xl font-bold text-white" data-id="element-97">{bundle.name}</h3>
                <p className="text-brand-muted text-sm mt-0.5" data-id="element-98">
                  {bundle.subtitle}
                </p>
                <div className="flex items-center justify-center sm:justify-start gap-2 mt-1" data-id="element-99">
                  <span className="text-brand-muted line-through text-sm" data-id="element-100">
                    ${bundle.original.toFixed(2)}
                  </span>
                  <span className="text-brand-orange font-bold text-xl" data-id="element-101">
                    ${bundle.price.toFixed(2)}
                  </span>
                </div>
              </div>

              <motion.a href={bundle.url} target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className={`w-full sm:w-auto px-8 py-3 rounded-xl font-bold transition-all text-center ${bundle.highlight ? 'bg-brand-orange text-white shadow-glow hover:shadow-glow-hover' : 'bg-white/10 text-white hover:bg-white/20'}`} data-id="element-102">
                {bundle.cta}
              </motion.a>
            </div>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-brand-muted bg-brand-card/30 py-4 rounded-xl border border-white/5" data-id="element-103">
        <div className="flex items-center gap-2" data-id="element-104">
          <ShieldCheckIcon className="w-5 h-5 text-brand-gold" data-id="element-105" />
          <span data-id="element-106">30-Day Money-Back Guarantee</span>
        </div>
        <span className="hidden sm:inline text-white/20" data-id="element-107">|</span>
        <div className="flex items-center gap-2" data-id="element-108">
          <LockIcon className="w-5 h-5 text-brand-gold" data-id="element-109" />
          <span data-id="element-110">Secure SSL Checkout</span>
        </div>
      </motion.div>
    </section>;
}